import { styled } from "@mui/material/styles";

const FiltersMain = styled("div")(({ theme }) => ({
  marginTop: "23px",
  "& ul": {
    borderBottom: "2px solid #E8E8E8",
    listStyle: "none",
    paddingBottom: "7px",
  },
  "& li": {
    display: "inline-block",
    padding: "0px 40px",
    position: "relative",
    cursor: "pointer",
  },
  "& li.active": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "center",
    color: "#0B0B0B",
    "&:after": {
      content: "''",
      position: "absolute",
      top: "calc(100% + 10px)",
      left: "0",
      background: "#0B0B0B",
      width: "100%",
      height: "2px",
    },
  },
}));

export { FiltersMain };
